// src/components/ui/slider.jsx
import * as React from "react";

export const Slider = React.forwardRef(
  (
    {
      value = [0],
      onValueChange,
      min = 0,
      max = 100,
      step = 1,
      className = "",
    },
    ref
  ) => {
    // We mirror the Radix style API: value is [number], onValueChange receives [number]
    const handleChange = (e) => {
      const v = Number(e.target.value);
      onValueChange([v]);
    };

    return (
      <div className={`relative flex items-center ${className}`} ref={ref}>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value[0]}
          onChange={handleChange}
          className="w-full cursor-pointer accent-primary" // Use theme primary color for accent
        />
      </div>
    );
  }
);

Slider.displayName = "Slider";
